import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/index";
import {
  homeFaqJsonLd,
  homeWebPageJsonLd,
  homeServicesItemListJsonLd,
} from "@/pages/index.seo";
import { brand } from "@/config/brand";

const SITE_URL = brand.url;
const OG_IMAGE = `${SITE_URL}/__l5e/assets-v1/aabeccab-688e-44b7-96b1-aaf70d6a2a8d/social-share-cover.png`;
const OG_ALT = "Digitally Baffled LTD — UK Digital Transformation Consultancy";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      {
        title:
          "Digital Transformation Consultancy UK | Digitally Baffled",
      },
      {
        name: "description",
        content:
          "UK digital transformation consultancy — websites from £500, apps from £1,500, PPC, SEO/AEO/GEO and ongoing support. Hampshire-based, working UK-wide.",
      },
      {
        name: "keywords",
        content:
          "digital transformation consultancy UK, web design small business, SEO AEO GEO UK, PPC Google Ads management, Ringwood Hampshire digital agency, Morgan Antell, Digitally Baffled, website design from £500, app development UK, ongoing digital support",
      },
      { property: "og:site_name", content: "Digitally Baffled" },
      {
        property: "og:title",
        content: "Digitally Baffled LTD — UK Digital Transformation Consultancy",
      },
      {
        property: "og:description",
        content:
          "Websites from £500, apps from £1,500, PPC & Google Ads, SEO, AEO & GEO, and ongoing support. Founded by Morgan Antell in Ringwood, Hampshire. Operating UK-wide and worldwide. Plain English. No jargon.",
      },
      { property: "og:url", content: `${SITE_URL}/` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:secure_url", content: OG_IMAGE },
      { property: "og:image:type", content: "image/png" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: OG_ALT },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:site", content: "@digitallybaffld" },
      { name: "twitter:creator", content: "@digitallybaffld" },
      {
        name: "twitter:title",
        content: "Digitally Baffled LTD — UK Digital Transformation Consultancy",
      },
      {
        name: "twitter:description",
        content:
          "Websites from £500, apps from £1,500, PPC & Google Ads, SEO, AEO & GEO, ongoing support £50–£75/hr. Founded by Morgan Antell, Ringwood, Hampshire. UK-wide and worldwide.",
      },
      { name: "twitter:image", content: OG_IMAGE },
      { name: "twitter:image:alt", content: OG_ALT },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/` }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(homeWebPageJsonLd) },
      {
        type: "application/ld+json",
        children: JSON.stringify(homeServicesItemListJsonLd),
      },
      { type: "application/ld+json", children: JSON.stringify(homeFaqJsonLd) },
    ],
  }),
  component: Page,
});
